export default [
  {
    path: '/marketing',
    name: 'index',
    component: () => import('@/views/marketing/index'),
    children:[
      {
        path: 'sign-up',
        name: 'SignUp',
        component: () => import('@/views/marketing/components/sign-up'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'professional-user',
        name: 'professional',
        component: () => import('@/views/marketing/components/professtional'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'client-profile',
        name: 'ClientProfile',
        component: () => import('@/views/marketing/components/client-profile'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'policy-mgm',
        name: 'PolicyMgm',
        component: () => import('@/views/marketing/components/policy-mgm'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'private-car',
        name: 'Private-Car',
        component: () => import('@/views/marketing/components/private-car'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'motorcycle',
        name: 'Motorcycle',
        component: () => import('@/views/marketing/components/motorcycle'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'travel',
        name: 'Travel',
        component: () => import('@/views/marketing/components/travel'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'refer',
        name: 'refer',
        component: () => import('@/views/marketing/components/refer'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'link-report',
        name: 'linkReport',
        component: () => import('@/views/marketing/components/link-report'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'blog',
        name: 'blog',
        component: () => import('@/views/marketing/components/blog'),
        meta: {
          keepAlive: false
        }
      },
    ],
    meta: {
      keepAlive: false
    }
  },
]
